import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvoicesService } from '../services/invoices.service';
import {
  localImages,
  stringsList,
  navigationConstants,
  folderStatuses,
} from '../../../constants/app-config';
import { SmallDialogComponent } from 'src/app/dashboard/atoms/small-dialog/small-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateFolderDialogComponent } from '../../dialogs/create-folder-dialog/create-folder-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { TemplateRunDialogComponent } from 'src/app/dashboard/atoms/template-run-dialog/template-run-dialog/template-run-dialog.component';
import { CustomTemplatesComponent } from './custom-templates/custom-templates.component';
import { Auth } from 'aws-amplify';
import {
  APIService,
  BulkDeleteServiceInput,
  ModelBulkInvoiceDeleteInput,
  ModelType,
  TF,
} from 'src/app/API.service';
import { FolderService } from '../services/folder.service';
import { ClientService } from '../services/client.service';
import { TemplateModel } from '../../models/template.model';
import { TemplateService } from '../../services/template.service';
import { Subscription } from 'rxjs';
import { SubSink } from 'subsink';
import { log } from 'console';
import { BulkDeleteService } from 'src/app/services/bulk-delete.service';
import { AssignDialogComponent } from '../../../atoms/assign-dialog/assign-dialog.component';
import { CreateInvoiceDialogComponent } from '../../dialogs/create-invoice-dialog/create-invoice-dialog.component';
import { CreatedInvoiceService } from '../services/created-invoice.service';
import { FolderPasswordService } from 'src/app/services/folder-password.service';
import { FolderPasswordDialogComponent } from '../../dialogs/folder-password-dialog/folder-password-dialog.component';
import { SetFolderPasswordDialogComponent } from '../../dialogs/set-folder-password-dialog/set-folder-password-dialog.component';

interface SortableItem {
  name?: string;
  invoicesCount?: number;
  status?: string;
  latestScanType?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-invoice-folder',
  templateUrl: './invoice-folder.component.html',
  styleUrls: ['./invoice-folder.component.css', '../../../styles/styles.css'],
})
export class InvoiceFolderComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public TF = TF;
  localImages = localImages;
  subscriptionResponse: any;
  isDownloadInProgress = false;
  res: any;
  isDone = false;
  user: any;
  folder: any;
  subfolders: SortableItem[] | any = [];
  invoiceStatus: any;
  invoicesFolderID: any = null;
  isEditing: boolean = false;
  invoices: any[] = [];
  isDataReady = false;
  folderName: string = 'null';
  isInvoices = true;
  isLoading = false;
  folderStatus: any = null;
  folderStatuses = folderStatuses;
  downloadLink: any = null;
  uploading: boolean = false;
  isAdded: boolean = false;
  isTemplatesEmpty: boolean = false;
  isSnackBarOpened: boolean = false;
  templates: any[] = [];
  currentFolders: any[] = [];
  folderExists: boolean = false;
  files: File[] = [];
  isDraggedOver: boolean = false;
  fullTemplates: any[] = [];
  areWeinRunningProccess: boolean = false;
  isStatusLabelHidden: boolean = false;
  isStopScanningInProccess: boolean = false;
  private folderUpdateSubscription: Subscription | undefined;
  originalFolderName: string = '';
  isHovered1: boolean = false;
  isHovered: boolean = false;
  selectedInvoicesNum: number = 0;
  isInputHovered: boolean = false;

  private nextToken: string | undefined;
  isAdditionalDataBeingFetched: boolean = false;
  userID!: string | null;
  private savedScrollPosition = 0;
  @ViewChild('scrollableContainer')
  scrollableContainer!: ElementRef<HTMLElement>;
  private prevScrollLeft = 0;
  isInputScrolled: boolean = false;
  queryParams = {};

  // Drag and drop related properties
  isDraggingInvoice: boolean = false;
  isDraggingFolder: boolean = false;
  dropTargetFolder: any = null;

  searchText: string = '';
  isSearching: boolean = false;
  searchedInvoices: any[] = [];
  searchedSubfolders: any[] = [];
  private searchDebounceTimer: any = null;

  sort: any = {
    name: '',
  };
  activeSort: string = '';
  // Tracks the index of the currently open dropdown, or null if no dropdown is open
  openDropdownIndex: number | null = null;

  // Tracks the index of the currently hovered row, or null if no row is hovered
  hoveredIndex: number | null = null;

  private routeSubscription: Subscription = new Subscription();

  // Add these properties with the other drag and drop properties
  isParentFolderDropTarget: boolean = false;
  draggedFolder: any = null;

  // Add these properties at the top of the class
  private lastMovedItem: any = null;
  private lastMovedItemType: 'invoice' | 'folder' | null = null;
  private lastMovedItemSourceFolder: any = null;

  constructor(
    private folderService: FolderService,
    public invoiceService: InvoicesService,
    public bulkDeleteService: BulkDeleteService,
    private fileUploadService: FileUploadService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private translate: TranslateService,
    private templateService: TemplateService,
    private apiService: APIService,
    private changeDetector: ChangeDetectorRef,
    private clientService: ClientService,
    private createdInvoiceService: CreatedInvoiceService,
    public folderPasswordService: FolderPasswordService
  ) { }
  async ngOnInit() {
    this.toggleSort('status');

    this.user = await Auth.currentAuthenticatedUser();
    this.userID = localStorage.getItem('userID');
    // Subscribe to route changes
    this.routeSubscription.add(
      this.route.params.subscribe(async params => {
        this.queryParams = params;
        this.invoicesFolderID = this.route.snapshot.paramMap.get('id');
        await this.getTemplates()
          .then(async () => {
            await this.getInvoices(this.invoicesFolderID, true);
            await this.getCreatedInvoices(); // Also fetch created invoices
            this.isDataReady = true;
            this.activateSubscriptions();
          })
          .then(async () => {
            await this.getCurrentFolders();
          });
      })
    );
  }

  // async searchInvoices(searchText: string) {
  //   console.log("searchInvoices: "+ searchText);
  //   this.searchText = searchText.trim();

  //   if (!this.searchText) {
  //     this.searchedInvoices = [...this.invoices];
  //     return;
  //   }

  //   const localResults = this.invoices.filter((invoice) =>
  //     (invoice.title ?? '').toLowerCase().includes(this.searchText.toLowerCase())
  //   );


  //   this.searchedInvoices = [...localResults];

  //   if (!this.nextToken) return;
  //   this.isSearching = true;
  //   try {
  //     const backendResults = await this.fetchMoreInvoicesFromBackend(
  //       this.folder.id,
  //       this.searchText
  //     );

  //     const combinedInvoices = [...localResults, ...backendResults];
  //     this.searchedInvoices = Array.from(
  //       new Map(
  //         combinedInvoices.map((invoice) => [invoice.id, invoice])
  //       ).values()
  //     );
  //   } catch (error) {
  //     console.error('❌ Error during backend search:', error);
  //   } finally {
  //     this.isSearching = false;
  //   }
  // }

  // async fetchMoreInvoicesFromBackend(
  //   folderID: string,
  //   searchText: string
  // ): Promise<any[]> {
  //   let backendResults: any[] = [];
  //   let nextToken: string | undefined = this.nextToken ?? undefined;

  //   const formattedSearchText = searchText.toLowerCase().replace(/\s+/g, '');

  //   try {
  //     const response = await this.invoiceService.getFilteredInvoices(
  //       folderID,
  //       formattedSearchText
  //     );

  //     if (response) {
  //       backendResults = response.items || [];
  //       nextToken = response.nextToken ?? undefined;
  //     }
  //   } catch (error) {
  //     console.error('❌ Error fetching invoices from backend:', error);
  //   }
  //   return backendResults;
  // }

  /**
   * Performs local fuzzy search on invoices and subfolders
   * @param searchText - The search query string
   */
  searchInvoices(searchText: string) {
    clearTimeout(this.searchDebounceTimer);

    if (!searchText.trim()) {
      this.searchText = '';
      this.searchedInvoices = [...this.invoices];
      this.searchedSubfolders = [...this.subfolders];
      this.isSearching = false;
      return;
    }

    this.isSearching = true;
    this.searchDebounceTimer = setTimeout(async () => {
      this.searchText = searchText.trim();

      try {
        const result = await this.invoiceService.SearchFolderInvoices(
          this.folder?.id,
          this.searchText,
          200
        );
        this.searchedInvoices = result?.items || [];
      } catch (err) {
        console.error('Backend search failed, falling back to local search', err);
        const directMatches = this.performLocalFuzzySearch(this.searchText, this.invoices);
        const subfolderInvoiceMatches: any[] = [];
        this.subfolders.forEach((subfolder: any) => {
          const items = subfolder?.invoices?.items;
          if (items && items.length) {
            const matches = this.performLocalFuzzySearch(this.searchText, items);
            matches.forEach((match: any) => subfolderInvoiceMatches.push(match));
          }
        });
        this.searchedInvoices = [...directMatches, ...subfolderInvoiceMatches]
          .sort((a, b) => (b._searchScore || 0) - (a._searchScore || 0));
      }

      this.searchedSubfolders = this.performLocalFuzzySearch(this.searchText, this.subfolders);
      this.isSearching = false;
    }, 250);
  }

  /**
   * Performs local fuzzy search on an array of items (invoices or subfolders)
   * @param query - The search query string
   * @param items - The array of items to search through
   * @returns Array of matching items sorted by relevance
   */
  private performLocalFuzzySearch(query: string, items: any[]): any[] {
    const queryLower = query.toLowerCase();
    const results: any[] = [];

    items.forEach((item: any) => {
      // Search in item title (primary field for invoices)
      const titleScore = this.calculateFuzzyScore(item.title || '', queryLower);

      // Search in item name (for both invoices and folders)
      const nameScore = this.calculateFuzzyScore(item.name || '', queryLower);

      // Take the highest score between title and name
      const bestScore = Math.max(titleScore, nameScore);

      // Only include results with a meaningful match (threshold 0.3)
      if (bestScore > 0.8) {
        results.push({
          ...item,
          _searchScore: bestScore
        });
      }
    });

    // Sort by search score (higher scores first)
    return results.sort((a, b) => (b._searchScore || 0) - (a._searchScore || 0));
  }

  /**
   * Calculates fuzzy match score between text and query
   * @param text - The text to search in
   * @param query - The search query
   * @returns Score between 0 and 1 (higher is better match)
   */
  private calculateFuzzyScore(text: string, query: string): number {
    const textLower = text.toLowerCase();
    const queryLower = query.toLowerCase();

    // Exact match gets highest score
    if (textLower === queryLower) {
      return 1.0;
    }

    // Direct substring match gets high score
    if (textLower.includes(queryLower)) {
      // Give higher score if match is near the beginning
      const position = textLower.indexOf(queryLower);
      const positionFactor = 1 - (position / textLower.length) * 0.1;
      return 0.9 * positionFactor;
    }

    // Check if text starts with query
    if (textLower.startsWith(queryLower)) {
      return 0.85;
    }

    // Calculate Levenshtein distance for fuzzy matching
    const distance = this.levenshteinDistance(textLower, queryLower);
    const maxLength = Math.max(textLower.length, queryLower.length);

    // Normalize distance to a score (0-1)
    const normalizedScore = 1 - (distance / maxLength);

    // Only return meaningful scores (threshold 0.3)
    return normalizedScore > 0.3 ? normalizedScore : 0;
  }

  /**
   * Calculates Levenshtein distance between two strings
   * Uses dynamic programming to find minimum edit distance
   * @param str1 - First string
   * @param str2 - Second string
   * @returns The edit distance between the strings
   */
  private levenshteinDistance(str1: string, str2: string): number {
    const len1 = str1.length;
    const len2 = str2.length;

    // Create a matrix to store distances
    const matrix: number[][] = Array(len1 + 1)
      .fill(null)
      .map(() => Array(len2 + 1).fill(0));

    // Initialize first column and row
    for (let i = 0; i <= len1; i++) {
      matrix[i][0] = i;
    }
    for (let j = 0; j <= len2; j++) {
      matrix[0][j] = j;
    }

    // Fill in the rest of the matrix
    for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
        const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,      // deletion
          matrix[i][j - 1] + 1,      // insertion
          matrix[i - 1][j - 1] + cost // substitution
        );
      }
    }

    return matrix[len1][len2];
  }

  get filteredInvoicesList() {
    return this.searchText ? this.searchedInvoices : this.invoices;
  }

  get filteredSubfoldersList() {
    return this.searchText ? this.searchedSubfolders : this.subfolders;
  }

  onInputMouseEnter() {
    const inputElement = document.getElementById('editFolderInput');
    if (inputElement) {
      inputElement.classList.add('hovered');
    }
  }

  async onScroll(e: any) {
    const scrollableContainer = this.scrollableContainer.nativeElement;
    const containerHeight = scrollableContainer.clientHeight;
    const scrollHeight = scrollableContainer.scrollHeight;
    const scrollTop = scrollableContainer.scrollTop;

    // Calculate the remaining distance to the bottom
    const remainToScrollToBottom = scrollHeight - (scrollTop + containerHeight);

    this.savedScrollPosition = scrollTop;

    // Define a threshold percentage (e.g., 90%) for triggering data loading
    const thresholdPercentage = 0.9;

    if (
      remainToScrollToBottom < containerHeight * thresholdPercentage &&
      !this.isAdditionalDataBeingFetched
    ) {
      this.isAdditionalDataBeingFetched = true;

      // Call your data fetching function here (replace this with your actual data fetching logic)
      if (!this.nextToken) {
        return;
      }
      await this.invoiceService
        .GetFolder(this.folder.id, 150, this.nextToken)
        .then((data: any) => {
          this.invoices = this.invoices.concat(data?.invoices?.items);
          this.folder = data;


          this.folder.invoices.items = JSON.parse(
            JSON.stringify(this.invoices)
          );
          this.searchedInvoices = [...this.invoices];
          this.searchedSubfolders = [...this.subfolders];
          this.isAdditionalDataBeingFetched = false;
          if (data.invoices.nextToken) {
            this.nextToken = data.invoices.nextToken;
          } else {
            this.nextToken = undefined;
          }
        })
        .catch((err) => console.log(err));
    }
  }

  startEditing(): void {
    this.isEditing = true;
  }

  cancelEditing(): void {
    this.isEditing = false;
    this.folderName = this.originalFolderName; // Reset the input value to the original value
    const inputElement = document.getElementById('editFolderInput');
    if (inputElement) {
      inputElement.classList.remove('hovered');
    }
  }

  finishEditing(): void {
    this.isEditing = false;
  }

  dragCounter = 0;
  prevDragCounter = 0;
  isDraggedOverTimeoutSet = false;

  @HostListener('window:dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    // fakultet
    if (!this.isDraggedOverTimeoutSet) {
      setTimeout(() => {
        setTimeout(() => {
          if (this.dragCounter === this.prevDragCounter) {
            this.isDraggedOver = false;
          }
        }, 100);
        this.isDraggedOverTimeoutSet = false;
        this.prevDragCounter = this.dragCounter;
      }, 100); // 1000 milliseconds (1 second) delay
      this.isDraggedOverTimeoutSet = true;
    }
    event.preventDefault();
    // Your custom logic when the drag leaves the window goes here.
  }

  @HostListener('window:dragover', ['$event'])
  onDragOverEv(event: DragEvent) {
    this.dragCounter++;
    if (this.selectedInvoicesNum > 0) return;
    const dataTransfer = event.dataTransfer;

    if (dataTransfer) {
      const isDraggingFromOutside = !dataTransfer.types.includes('Files');
      if (isDraggingFromOutside) {
        // this.onDragOver(event);
        return;
      } else {
        this.onDragOver(event);
      }
    }
    event.preventDefault();
  }

  async getCurrentFolders() {
    this.currentFolders = JSON.parse(localStorage.getItem('folders') || '[]');
  }

  get selectedInvoices(): number {
    return this.invoices.filter((invoice: any) => {
      return invoice.selected;
    }).length;
  }

  toggleAllSelection(seed: boolean) {
    this.invoices.forEach((invoice: any) => {
      invoice.selected = seed;
    });
    if (seed == true) {
      this.selectedInvoicesNum = this.invoices.length;
    } else {
      this.selectedInvoicesNum = 0;
    }
  }

  toggleCheckbox(invoice: any) {
    setTimeout(() => {
      const index = this.invoices.findIndex(
        (inv: any) => inv.id === invoice.id
      );
      if (index !== -1) {
        this.invoices[index].selected = !this.invoices[index].selected;
        if (this.invoices[index].selected === true) {
          this.selectedInvoicesNum++;
        } else {
          this.selectedInvoicesNum--;
        }
      }
    }, 250);
  }

  async getTemplates() {
    this.isLoading = true;
    let userId = localStorage.getItem('userID');

    // Determining productsEnabled value based on your condition
    const productsEnabled = this.someConditionToDetermineIfProductsEnabled();

    // Constructing the clientIDProductsEnabledPK key
    const clientIDProductsEnabledPK = `${userId}#${productsEnabled}`;

    await this.templateService
      .ListTemplatesByClientIDProductsEnabledPK(
        clientIDProductsEnabledPK,
        undefined,
        undefined,
        undefined,
        100
      )
      .then((data) => {
        data.items.reverse().forEach((el: any) => {
          el.template = JSON.parse(el.template);
          const keysArray = Object.keys(el.template);
          const keysAsStrings = keysArray.map((key) => String(key));

          let fullTemplate: any = {
            name: el.name,
            description: el.description,
          };
          let additionalFields: any = [];
          for (const [key, value] of Object.entries(el.template)) {
            if (this.templateService.isMandatoryKey(key)) {
              fullTemplate[key] = value;
            } else {
              additionalFields.push({ key: key, value: value });
            }
          }
          let template: TemplateModel = {
            id: el.id,
            _name: el.name,
            _description: el.description ? el.description : '',
            _updatedAt: el.updatedAt,
            _isFixedValueEnabled: el.isFixedValueEnabled,
            _fixedValues: el.fixedValues
          };
          this.templates.push(template);
          this.fullTemplates.push({
            template: fullTemplate,
            additionalFields: additionalFields,
            orderedKeys: keysAsStrings,
          });
        });
        this.templates = this.sortTempaltes(this.templates);
        setTimeout(() => {
          this.isTemplatesEmpty = this.templates.length ? false : true;
        }, 1000);
      })
      .catch((err) => console.log(err));

    this.isLoading = false;
  }

  someConditionToDetermineIfProductsEnabled(): string {
    return 'TRUE';
  }

  sortTempaltes(templates: any) {
    return templates.sort((a: any, b: any) => {
      const createdAtA = new Date(a._updatedAt).getTime();
      const createdAtB = new Date(b._updatedAt).getTime();
      return createdAtB - createdAtA;
    });
  }

  activateSubscriptions() {
    this.subs.sink = this.invoiceService
      .OnUpdateFolderListener(this.user.attributes.sub)
      .subscribe((folders: any) => {
        console.log('folders');

        if (folders.value.data.onUpdateFolder.id !== this.invoicesFolderID) {
          return;
        }
        this.getInvoices(this.invoicesFolderID, false);
      });
    this.subs.sink = this.invoiceService
      .OnUpdateInvoiceListener()
      .subscribe((response) => {
        console.log(this.invoicesFolderID);

        if (
          this.invoicesFolderID !==
          response?.value?.data?.onUpdateInvoice?.folderID
        ) {
          return;
        }

        let foundInvoice = this.invoices.find(
          (el) => el.id === response.value.data?.onUpdateInvoice.id
        );
        if (foundInvoice) {
          foundInvoice.thumbnailPath =
            response.value.data?.onUpdateInvoice.thumbnailPath;
        } else this.invoices.push(response.value.data?.onUpdateInvoice);
        this.uploading = false;
        this.isDownloadInProgress = false;
        if (!this.isSnackBarOpened) {
          this.isSnackBarOpened = true;
          this.snackBar.open('Upload was successfull', '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });
          setTimeout(() => {
            this.isSnackBarOpened = false;
          }, 5000);
        }
      });
  }

  async promptFolderPassword(folder: any): Promise<boolean> {
    return new Promise((resolve) => {
      const ref = this.dialog.open(FolderPasswordDialogComponent, {
        width: '440px',
        disableClose: true,
        data: {
          folderName: folder.name,
          passwordHash: folder.passwordHash,
          folderId: folder.id,
        },
      });
      ref.afterClosed().subscribe((result: boolean) => resolve(!!result));
    });
  }

  setFolderPassword(event: Event, item: any): void {
    event.stopPropagation();
    const ref = this.dialog.open(SetFolderPasswordDialogComponent, {
      width: '460px',
      data: {
        folderId: item.id,
        folderName: item.name,
        isPasswordProtected: !!item.isPasswordProtected,
      },
    });
    ref.afterClosed().subscribe((result: any) => {
      if (!result || result.action === 'cancel') return;
      if (result.action === 'set') {
        item.isPasswordProtected = true;
        item.passwordHash = result.passwordHash;
        if (item.id === this.folder?.id) {
          this.folder.isPasswordProtected = true;
          this.folder.passwordHash = result.passwordHash;
        }
      } else if (result.action === 'remove') {
        item.isPasswordProtected = false;
        item.passwordHash = null;
        if (item.id === this.folder?.id) {
          this.folder.isPasswordProtected = false;
          this.folder.passwordHash = null;
        }
      }
    });
  }

  async getInvoices(id: any, isLoadingOff?: boolean) {
    if (isLoadingOff) {
      this.isLoading = true;
    }
    let invoices: any = await this.invoiceService
      .GetFolder(id, 10000)
      .catch((err) => console.log(err));

    if (invoices?.isPasswordProtected && !this.folderPasswordService.isUnlocked(id) && !this.folderPasswordService.wasJustUnlocked(id)) {
      const unlocked = await this.promptFolderPassword(invoices);
      if (!unlocked) {
        this.isLoading = false;
        if (invoices.parentFolderID) {
          this.router.navigate(['/invoices', invoices.parentFolderID]);
        } else {
          this.router.navigate(['/invoices']);
        }
        return;
      }
    }

    this.folderName = invoices.name;
    this.originalFolderName = invoices.name;
    this.invoices = invoices.invoices.items;
    this.folderStatus = invoices.status;
    this.folder = invoices;
    this.subfolders = invoices.childFolders.items.map((item: any) => ({
      ...item,
      type: 'folder',
      latestScanType: this.determineIfGoodsAndMaterial(item)
    }));

    this.downloadLink = invoices.downloadLink;
    this.invoiceStatus = invoices.areThereMissingFields;
    this.isInvoices = invoices.invoices.items.length !== 0;
    this.invoicesFolderID = invoices.id;
    if (invoices.invoices.nextToken) {
      this.nextToken = invoices.invoices.nextToken;
    } else this.nextToken = undefined;
    this.invoices.forEach((invoice: any, index: number) => {
      console.log(
        `📄 Invoice ${index + 1}: ${invoice.title || 'Untitled Invoice'}`
      );
    });
    this.searchedInvoices = [...this.invoices];
    this.searchedSubfolders = [...this.subfolders];
    this.isLoading = false;
  }

  async getZipFile(templateId: string) {
    this.invoiceService
      .GetFolder(this.invoicesFolderID)
      .then((data: any) => {
        let selectedFolderInvoices: any = [];
        data.invoices.items.forEach((invoice: any) => {
          selectedFolderInvoices.push({
            invoiceName: invoice.name,
            folderID: this.invoicesFolderID,
            templateID: templateId,
          });
        });
        this.invoiceService
          .RunFolder(selectedFolderInvoices)
          .then((data) => { })
          .then((data) => { })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => console.log(err));
  }

  downloadFile(url: string, filename: string) {
    // Fetch the file as a blob to force download (cross-origin URLs ignore download attribute)
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = filename;
        downloadLink.click();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      })
      .catch(err => {
        console.error('Failed to download file:', err);
        // Fallback: try direct download (may open in browser for cross-origin)
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.target = '_blank';
        downloadLink.click();
      });
  }

  downloadInvoice(invoice: any, event: any) {
    event.stopPropagation();
    const extension = invoice.name.split('.').pop();
    const filename = invoice.title ? `${invoice.title}.${extension}` : invoice.name.split('/').pop() || 'file.pdf';
    this.downloadFile(invoice.name, filename);
  }

  navigateBack() {
    if (this.folder?.parentFolderID) {
      this.router.navigate(['/invoices', this.folder.parentFolderID]);
    } else {
      this.router.navigate(['/invoices']);
    }
  }

  async navigateToSubfolder(subfolderId: string) {
    const subfolder = this.subfolders.find((s: any) => s.id === subfolderId);
    if (subfolder?.isPasswordProtected && !this.folderPasswordService.isUnlocked(subfolderId)) {
      const unlocked = await this.promptFolderPassword(subfolder);
      if (!unlocked) return;
    }
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['invoices', subfolderId]);
      this.router.navigate(['invoices', subfolderId]);
    });
  }

  async bulkDeleteInvoices() {
    let invoicesForDelete = this.invoices.filter((invoice: any) => {
      return invoice.selected;
    });
    let plural = invoicesForDelete.length > 1 ? true : false;
    let messages = {
      heading: this.translate.instant('deleteMarkedInvoices'),
      contentPartOne: this.translate.instant('deleteMarkedInvoicesText'),
      action: this.translate.instant('Delete documents'),
    };

    if (!plural) {
      messages.heading = 'Delete selected document';
      messages.contentPartOne =
        "Are you sure you want to delete selected document, you can't undo this action.";
      messages.action = 'Delete document';
    }

    let dialogData = {
      heading: messages.heading,
      contentPartOne: messages.contentPartOne,
      //  contentPartTwo: this.translate.instant('invoiceContentPartTwo'),
      action: messages.action,
    };

    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response?.action === stringsList.doAction) {
        this.isLoading = true;

        let ids: BulkDeleteServiceInput = {
          ids: [],
          type: ModelType.INVOICE,
        };
        let selected = this.invoices.filter((invoice: any) => {
          return invoice.selected;
        });

        ids.ids = selected.map((invoice: any) => {
          return invoice.id;
        });

        await this.bulkDeleteService
          .BulkDeleteService(ids)
          .catch((err) => console.log(err));
        this.snackBar.open('Selected invoices have been deleted', 'Dismiss', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        this.invoices = this.invoices.filter((invoice: any) => {
          return !invoice.selected;
        });
        this.isLoading = false;
      }
    });
  }

  async deleteInvoice(invoice: any, event: any) {
    event.stopPropagation();
    let dialogData = {
      heading: this.translate.instant('deleteInvoice'),
      contentPartOne: this.translate.instant('invoiceContentPartOne'),
      // contentPartTwo: this.translate.instant('invoiceContentPartTwo'),
      action: this.translate.instant('deleteDialogAction'),
    };

    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response?.action === stringsList.doAction) {
        this.isLoading = true;
        await this.invoiceService
          .DeleteInvoice({ id: invoice.id })
          .then()
          .catch((err) => console.log(err));
        this.snackBar.open('Invoice has been deleted', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        this.getInvoices(this.invoicesFolderID, true);
      }
    });
  }

  openSmallDialogProperties(data: any) {
    return {
      width: '480px',
      data: data,
    };
  }

  openProgressDialogProperties() {
    return {
      width: '390px',
    };
  }

  addInvoice() {
    document.getElementById('upload-file')?.click();
  }

  getBase64(file: File): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string | null);
      reader.onerror = (error) => reject(error);
    });
  }



  async addPhoto(fileInput: any) {
    if (this.selectedInvoicesNum > 0) return;
    const files = fileInput.target.files;
    if (files && files.length > 0) {
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      for (const file of files) {
        if (file.size > maxSize) {
          this.snackBar.open('File too large', '', {
            duration: 5000,
            panelClass: ['red-snackbar'],
          });
          return;
        }
      }
      console.log('1');


      const promises: Promise<{ file: File; base64: string | null }>[] = [];
      if (files && Object.keys(files).length > 0) {
        this.uploading = true;
        for (let key of Object.keys(files)) {
          const file = files[key];
          if (!this.checkImgFileSize(file.size)) {
            const base64Promise = this.getBase64(file).then((base64) => ({
              file,
              base64,
            }));
            promises.push(base64Promise);
          }
        }
        console.log('2');


        Promise.all(promises).then(async (fileDataArray) => {
          const filesToUpload = [];
          for await (let fileData of fileDataArray) {
            const presignedUrl = await this.fileUploadService.getPresignedUrl(
              fileData.file
            );
            filesToUpload.push({ url: presignedUrl, title: fileData.file.name });
          }
          console.log('3');


          Promise.all(filesToUpload).then(async (uploadedFiles) => {
            const uploadPromises = [];
            for await (let file of uploadedFiles) {
              uploadPromises.push(this.uploadInvoice(file.title, file.url));
            }
            console.log('4');


            Promise.all(uploadPromises)
              .then(() => {
                this.isAdded = true;
                this.isInvoices = true;
                this.getInvoices(this.invoicesFolderID, false)
                  .then(() => {
                    this.uploading = false;
                  })
                  .catch((err) => {
                    this.snackBar.open('Upload error', '', {
                      duration: 5000,
                      panelClass: ['white-snackbar'],
                    });
                    console.log(err);
                  });
              })
              .catch((error) => {
                console.error('Error occurred during invoice upload:', error);
                this.snackBar.open('Upload error', '', {
                  duration: 5000,
                  panelClass: ['white-snackbar'],
                });
              });
          });
        });
      }
    }
  }


  async uploadInvoice(invoiceTitle: string, url: string): Promise<any> {
    try {
      return await this.invoiceService.CreateInvoice({
        name: url,
        folderID: this.invoicesFolderID,
        clientID: this.user.attributes.sub,
        title: invoiceTitle,
      });
    } catch (err) {
      console.error('Invoice upload failed:', err);
    }
  }



  editFolderNameDialogProperties() {
    return {
      width: '348px',
      height: '236px',
      data: {
        isEdit: true,
        folderId: this.invoicesFolderID,
      },
    };
  }

  async editFolderName() {
    const inputElement = document.getElementById('editFolderInput');
    inputElement?.blur();

    if (inputElement) {
      inputElement.classList.remove('hovered');
    }
    if (this.folderName.trim() === this.originalFolderName.trim()) {
      return;
    }
    // const folderExists = this.currentFolders.some(
    //   (folder: any) => folder.name === this.folderName
    // );
    // if (folderExists) {
    //   this.folderExists = true;
    //   return;
    // }

    if (this.folderName.trim() === '') {
      this.folderName = this.originalFolderName;
      return;
    }

    const editedFolder = {
      name: this.folderName.trim(),
      id: this.invoicesFolderID,
    };
    await this.folderService
      .UpdateFolder(editedFolder)
      .then((res) => {
        this.originalFolderName = res.name;
        this.snackBar.open('Changes successfully saved', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      })
      .catch((err) => console.log(err));
  }

  closeDialog() {
    this.dialog.closeAll();
  }


  createInvoice() {
    // Check for saved memorandum before opening dialog
    const userId = this.userID || this.user?.attributes?.sub;
    const savedMemorandumUrl = userId ? this.createdInvoiceService.getSavedMemorandumUrl(userId) : null;
    const savedMemorandumFileName = userId ? this.createdInvoiceService.getSavedMemorandumFileName(userId) : null;

    const dialogRef = this.dialog.open(CreateInvoiceDialogComponent, {
      width: '900px',
      maxHeight: '90vh',
      data: {
        folderId: this.invoicesFolderID,
        folderName: this.folderName,
        hasSavedMemorandum: !!savedMemorandumUrl,
        savedMemorandumFileName: savedMemorandumFileName || 'memorandum.docx'
      },
      panelClass: ['create-invoice-dialog-container'],
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(async (invoiceData) => {
      if (invoiceData) {
        try {
          // Get actual client ID from clientService (not userID from localStorage)
          const currentUserId = this.userID || this.user?.attributes?.sub;
          if (!currentUserId) {
            this.snackBar.open('Unable to get user information', '', {
              duration: 3000,
              panelClass: ['white-snackbar'],
            });
            return;
          }

          // Fetch the actual client to get the real clientID
          const client = await this.clientService.GetClient(currentUserId);
          const clientId = client.id;
          
          if (!clientId) {
            this.snackBar.open('Unable to get client information', '', {
              duration: 3000,
              panelClass: ['white-snackbar'],
            });
            return;
          }

          // Get or create IZLAZNE FAKTURE folder at root level
          this.snackBar.open('Creating invoice...', '', {
            duration: 2000,
            panelClass: ['white-snackbar'],
          });
          
          const izlazneFaktureFolderId = await this.createdInvoiceService.getOrCreateIzlazneFaktureFolder(clientId);

          // Upload memorandum, convert to PDF, and create the Invoice record
          this.snackBar.open(invoiceData.useSavedMemorandum ? 'Converting memorandum to PDF...' : 'Uploading and converting memorandum...', '', {
            duration: 10000,
            panelClass: ['white-snackbar'],
          });

          await this.createdInvoiceService.handleMemorandumUpload(
            invoiceData.memorandumFile || null,
            izlazneFaktureFolderId,
            clientId,
            invoiceData,
            this.fileUploadService,
            invoiceData.useSavedMemorandum ? savedMemorandumUrl! : undefined
          );

          this.snackBar.open(`Invoice ${invoiceData.invoiceNumber} created successfully in "${this.createdInvoiceService.IZLAZNE_FAKTURE_FOLDER}" folder`, '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });

          // If we're currently in the IZLAZNE FAKTURE folder, refresh the list
          if (this.invoicesFolderID === izlazneFaktureFolderId) {
            this.getInvoices(this.invoicesFolderID, false);
            await this.getCreatedInvoices();
          }
        } catch (error) {
          console.error('Error saving invoice:', error);
          this.snackBar.open('Error creating invoice. Please try again.', '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });
        }
      }
    });
  }

  // Created invoices for the current folder
  createdInvoices: any[] = [];

  async getCreatedInvoices() {
    try {
      this.createdInvoices = await this.createdInvoiceService.getInvoicesByFolder(this.invoicesFolderID);
    } catch (error) {
      console.error('Error fetching created invoices:', error);
      this.createdInvoices = [];
    }
  }

  async openYourBooks() {
    try {
      const clientId = this.userID || this.user?.attributes?.sub;
      if (!clientId) {
        this.snackBar.open('Unable to get user information', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
        return;
      }

      const clientData = await this.clientService.GetClient(clientId);
      const driveFileId = clientData?.cicDriveFileId;

      if (driveFileId) {
        const driveUrl = `https://docs.google.com/spreadsheets/d/${driveFileId}/edit`;
        window.open(driveUrl, '_blank');
      } else {
        this.snackBar.open('No CIC report found. Please run a report first.', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
      }
    } catch (error) {
      console.error('Error opening Your Books:', error);
      this.snackBar.open('Failed to open Your Books', '', {
        duration: 3000,
        panelClass: ['white-snackbar'],
      });
    }
  }

  async deleteSubFolder(event: any, item: any) {
    event.stopPropagation();
    let dialogData = {
      heading: this.translate.instant('deleteFolder'),
      contentPartOne: this.translate.instant('folderContentPartOne'),
      contentFile: item.name,
      contentPartTwo: this.translate.instant('folderContentPartTwo'),
      action: this.translate.instant('Delete folder'),
      showCloseButton: false,
    };

    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response && response.action === stringsList.doAction) {
        await this.invoiceService
          .DeleteFolder({ id: item.id })
          .then(async (res) => {
            this.subfolders = this.subfolders.filter((item: any) => item.id !== res.id);
            this.snackBar.open(
              `The "${res.name}" folder has been deleted`,
              '',
              {
                duration: 5000,
                panelClass: ['white-snackbar'],
              }
            );
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  async deleteFolder() {
    let dialogData = {
      heading: this.translate.instant('deleteFolder'),
      contentPartOne: this.translate.instant('folderContentPartOne'),
      contentPartTwo: this.translate.instant('folderContentPartTwo'),
      action: this.translate.instant('Delete invoice'),
    };

    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response?.action === stringsList.doAction) {
        await this.invoiceService
          .DeleteFolder({ id: this.invoicesFolderID })
          .then(() => {
            this.router.navigate(['/invoices']);
          })
          .catch((err) => {
            console.log(err);
          });
        this.snackBar.open('SUCCESS', 'Folder is deleted', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      }
    });
  }

  generateFolderStatusLabel() {
    switch (this.folderStatus) {
      case folderStatuses.INIT:
      case folderStatuses.IN_QUEUE:
      case folderStatuses.IN_PROCESSING:
        return this.translate.instant('processStatuses.processing');
      case folderStatuses.SUCCESS:
        return this.translate.instant('processStatuses.completed');
      case folderStatuses.FAILED:
        return this.translate.instant('processStatuses.failed');
      default:
        return '';
    }
  }


  isProcessingSubfolder(status: any) {
    if (
      status === folderStatuses.IN_PROCESSING ||
      status === folderStatuses.IN_QUEUE
    ) {
      return true;
    }
    return false;
  }

  isProcessing() {
    if (
      [folderStatuses.IN_PROCESSING, folderStatuses.IN_QUEUE].includes(
        this.folderStatus
      )
    ) {
      this.areWeinRunningProccess = true;
      return true;
    }
    this.areWeinRunningProccess = false;
    return false;
  }

  generateFolderLabelColorClass() {
    return this.generateFolderStatusLabel()?.toLowerCase();
  }

  disableDownloadButton() {
    if (!this.downloadLink) {
      return true;
    }
    return false;
  }

  private isGoodsAndMaterialRequiredFile(fileName: string): boolean {
    const name = fileName?.toLowerCase() || '';
    return name.endsWith('.txt') || name.endsWith('.xlsx') || name.endsWith('.xls');
  }

  hasFilesRequiringGoodsAndMaterialProcessing(item: any): boolean {
    if (!item?.invoices?.items || item.invoices.items.length === 0) {
      return false;
    }
    return item.invoices.items.some((invoice: any) =>
      this.isGoodsAndMaterialRequiredFile(invoice?.name)
    );
  }

  hasFilesRequiringGoodsAndMaterialProcessingInCurrentFolder(): boolean {
    if (!this.invoices || this.invoices.length === 0) {
      return false;
    }
    return this.invoices.some((invoice: any) =>
      this.isGoodsAndMaterialRequiredFile(invoice?.name)
    );
  }

  renderStatusComponent() {
    return this.isInvoices && this.folderStatus;
  }

  openCreateFolderDialogProperties() {
    return {
      width: '400px',
      height: '284px',
      data: {
        isEdit: false,
        currentFolders: this.subfolders,
        parentFolderID: this.invoicesFolderID,
      },
    };
  }

  createFolder() {
    const dialogRef = this.dialog.open(
      CreateFolderDialogComponent,
      this.openCreateFolderDialogProperties()
    );
    dialogRef.afterClosed().subscribe((response: any) => {
      if (response) {
        this.subfolders = [...this.subfolders, {
          ...response,
          type: 'folder',
          latestScanType: this.determineIfGoodsAndMaterial(response)
        }];
        if (this.activeSort) {
          this.refreshSort();
        }
        this.snackBar.open(`Folder "${response.name}" has been created`, '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      }
    });
  }



  async openDialog(folder: any) {
    this.invoiceService.openTemplateDialog(folder);
    this.isDownloadInProgress = false;
  }

  runFolder(folderID: string, folder: any, isScanIncludedProducts: TF) {
    this.areWeinRunningProccess = true;
    this.isStatusLabelHidden = false;
    this.folder.status = folderStatuses.IN_PROCESSING;
    this.folderStatus = folderStatuses.IN_PROCESSING;
    this.invoiceService
      .CreateFolderScanTask({ folderID, isScanIncludedProducts })
      .then((res) => {
        this.areWeinRunningProccess = false;
      })
      .catch((err) => {
        this.areWeinRunningProccess = false;
        console.log(err);
      });
  }

  async runNano(folder: any) {
    this.areWeinRunningProccess = true;
    this.isStatusLabelHidden = false;
    this.folder.status = folderStatuses.IN_PROCESSING;
    this.folderStatus = folderStatuses.IN_PROCESSING;

    const response = await this.folderService.predictFolderAsync(
      folder.id,
      `${window.location.origin}/invoices/${this.folder.id}?navbar_hidden=true&is_iframe=true`
    );

    // const updatedInvoices = response.data.predictFolder.invoices
    // // Update this.invoices with the data from updatedInvoices
    // this.invoices = this.invoices.map(invoice => {
    //   const updatedInvoice = updatedInvoices.find((updated: any) => updated.id === invoice.id);
    //   return updatedInvoice ? { ...invoice, ...updatedInvoice } : invoice;
    // });

    // // Update the folder's invoices as well
    // if (this.folder && this.folder.invoices && this.folder.invoices.items) {
    //   this.folder.invoices.items = this.invoices;
    // }

    // // Trigger change detection to update the view
    // this.changeDetector.detectChanges();
    // this.isStopScanningInProccess = false;
    // this.areWeinRunningProccess = false;
    // this.folderStatus = folderStatuses.SUCCESS;
    // this.folder.status = folderStatuses.SUCCESS;
  }

  openImageInNewTab(invoice: any) {
    // For TXT files, open the generated thumbnail instead of the raw text file
    const originalUrl = invoice?.name?.toLowerCase().endsWith('.txt') && invoice.thumbnailPath
      ? invoice.thumbnailPath
      : invoice.name;

    window.open(originalUrl, '_blank');
  }

  openTemplateModal(event: any, folderID: any) {
    this.invoiceService.stopDefault(event);
    console.log('ale 2');

    const dialogRef = this.dialog.open(TemplateRunDialogComponent, {
      width: '780px',
      height: '550px',
      panelClass: ['select-template-dialog'],
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;
      const input = {
        folderID: folderID.id,
        templateID: data.templateID,
        format: data.templateId === 'eLine' ? 'xml' : 'excel',
      };
      this.isDownloadInProgress = true;
      this.invoiceService.ExportFolderInvoices(input).then((data) => {
        this.invoiceService.downloadExcelFile(data);
        this.isDownloadInProgress = false;
      });
    });
  }

  openTemplateDialog(item: any) {
    let duplicatedArray = JSON.parse(JSON.stringify(item.invoices.items));
    console.log(duplicatedArray);
    duplicatedArray.forEach((item: any, index: any, array: any) => {
      item.missingFields = JSON.parse(item.missingFields);
    });
    this.openTemplateAndDownloadDialog(item.id, item, duplicatedArray);
  }

  async downloadNano(folder: any) {
    const response: any = await this.folderService.exportFolderFromNano(
      folder.id
    );
    console.log(
      'response.data.exportFolderFromNano.csvFileUrl',
      response.data.exportFolderFromNano.csvFileUrl
    );
    console.log(
      'response.data.exportFolderFromNano.xlsxFileUrl',
      response.data.exportFolderFromNano.xlsxFileUrl
    );

    this.downloadFile(response.data.exportFolderFromNano.xlsxFileUrl, 'archive.xlsx');
  }

  openTemplateAndDownloadDialog(
    folderID: any,
    item?: any,
    duplicatedArray?: any[]
  ) {
    const dialogRef = this.dialog.open(TemplateRunDialogComponent, {
      width: '480px',
      data: {
        folderID: folderID,
        folder: item,
        isTemplatesEmpty: this.isTemplatesEmpty,
        templatesList: this.templates,
        template: item,
        duplicatedArray: duplicatedArray,
        fullTemplates: this.fullTemplates,
      },
      panelClass: ['select-template-dialog'],
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;
      item = this.invoiceService.updateInvoicesItems(item, data);
    });
  }

  checkImgFileSize(imgSizeInBytes: any): boolean {
    if (imgSizeInBytes * 0.000001 > 10) {
      this.snackBar.open('ERROR', 'Maximum size of image (2mb)', {
        duration: 5000,
        panelClass: ['white-snackbar'],
      });
      return true;
    }
    return false;
  }

  checkTemplatesLength() {
    if (this.templates?.length) {
      return true;
    } else {
      return false;
    }
  }

  onDragOver(event: DragEvent) {
    this.isDraggedOver = true;
    event.preventDefault();
  }

  onDragEnd(event: DragEvent) {
    this.isDraggedOver = false;
  }

  async addPhoto3(validFiles: File[]) {
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes


    for (const file of validFiles) {
      if (file.size > maxSize) {
        this.snackBar.open('File too large', '', {
          duration: 5000,
          panelClass: ['red-snackbar'],
        });
        return;
      }
    }


    const promises: Promise<{ file: File; base64: string | null }>[] = [];


    if (validFiles.length > 0) {
      this.uploading = true;


      for (let file of validFiles) {
        if (!this.checkImgFileSize(file.size)) {
          const base64Promise = this.getBase64(file).then((base64) => ({
            file,
            base64,
          }));
          promises.push(base64Promise);
        }
      }


      try {
        const processedFiles = await Promise.all(promises);
        const filesToUpload = [];


        for (let processedFile of processedFiles) {
          const presignedUrl = await this.fileUploadService.getPresignedUrl(
            processedFile.file
          );


          filesToUpload.push({ url: presignedUrl, title: processedFile.file.name });
        }


        const uploadedPromises = filesToUpload.map((file) =>
          this.uploadInvoice(file.title, file.url)
        );


        await Promise.all(uploadedPromises);


        this.snackBar.open('Upload was successful', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });


        this.isAdded = true;
        this.isInvoices = true;


        await this.getInvoices(this.invoicesFolderID, true);
        this.uploading = false;
      } catch (error) {
        console.error('Error occurred during invoice upload:', error);
        this.snackBar.open('Upload error', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      }
    }
  }



  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    const allowedTypes = [
      'image/png',
      'image/gif',
      'image/jpeg',
      'application/pdf',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
    ];
    const allowedExtensions = ['.png', '.gif', '.jpg', '.jpeg', '.pdf', '.txt', '.xlsx', '.xls'];

    if (files && files.length > 0) {
      const validFiles: any = Array.from(files).filter((file: any) =>
        allowedTypes.includes(file.type) ||
        allowedExtensions.some((ext) => file.name?.toLowerCase().endsWith(ext))
      );
      this.isDraggedOver = false;
      if (!validFiles.length) {
        this.snackBar.open(
          'Wrong file type, only images, PDF, TXT, and XLSX files allowed',
          'Dismiss',
          {
            duration: 5000,
            panelClass: ['white-snackbar'],
          }
        );
      } else {
        this.addPhoto3(validFiles);
      }
    }
  }
  // drag and drop end

  async stopScanning(folderID: string, folder: any) {
    let foundedFolder: any;
    let dialogData = {
      heading: this.translate.instant('Stop scanning invoices?'),
      contentPartOne: this.translate.instant(
        'Are you sure you want to stop scanning process?'
      ),
      action: this.translate.instant('Stop scanning'),
    };
    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response.action === stringsList.doAction) {
        this.isStopScanningInProccess = true;
        await this.folderService
          .CancelFolderScanTask({
            folderID: folderID,
          })
          .then((res) => {
            this.isStopScanningInProccess = false;
            this.isStatusLabelHidden = true;
            this.areWeinRunningProccess = false;
            this.folderStatus = null;
            setTimeout(() => {
              this.snackBar.open('The scanning has been stopped', '', {
                duration: 5000,
                panelClass: ['white-snackbar'],
              });
            }, 2000);
          })
          .catch((err) => {
            this.isStatusLabelHidden = false;
            this.isStopScanningInProccess = false;
            console.log(err);
          });
      }
    });
  }

  startEditingInvoice(invoice: any) {
    console.log('Editing invoice:', invoice.title);
    invoice.originalTitle = invoice.title;
    invoice.isEditing = true;
    this.changeDetector.detectChanges();
  }

  saveInvoiceName(invoice: any) {
    console.log('Invoice name before saving:', invoice.title);

    if (!invoice.title?.trim()) {
      this.snackBar.open('Invoice title cannot be empty', '', {
        duration: 3000,
        panelClass: ['red-snackbar'],
      });
      return;
    }

    if (invoice.title === invoice.originalTitle) {
      console.log('No changes detected, closing edit mode.');
      invoice.isEditing = false;
      this.changeDetector.detectChanges();
      return;
    }

    invoice.isEditing = false;
    this.changeDetector.detectChanges();

    this.invoiceService
      .UpdateInvoiceTitle({
        id: invoice.id,
        title: invoice.title,
      })
      .then(() => {
        this.snackBar.open('Invoice title updated successfully', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
      })
      .catch((error) => {
        console.error('Error updating invoice:', error);
        this.snackBar.open('Error updating invoice', '', {
          duration: 3000,
          panelClass: ['red-snackbar'],
        });
      });
  }

  getStatus(item: any) {
    return item.status;
  }

  checkLengthOfInvoicesObj(item: any) {
    if (item.invoicesCount > 0) {
      return false;
    } else {
      return true;
    }
  }


  toggleSort(key: string) {
    let val = '';
    if (!this.sort[key]) {
      this.sort[key] = val = 'desc';
    } else if (this.sort[key] == 'desc') {
      this.sort[key] = val = 'asc';
    } else {
      this.sort[key] = val = '';
    }
    this.sort = {};
    this.activeSort = key;
    this.sort[this.activeSort] = val;
  }

  refreshSort() {
    if (this.activeSort && this.sort[this.activeSort]) {
      const currentSort = { ...this.sort };
      this.sort = {};
      this.sort[this.activeSort] = currentSort[this.activeSort];
    }
  }

  /**
   * Toggles the dropdown open or closed.
   * @param index - The index of the row whose dropdown is being toggled.
   * @param state - The state of the dropdown (true for open, false for closed).
   */
  /**
   * Toggles the dropdown open or closed.
   * @param index - The index of the row whose dropdown is being toggled.
   * @param state - The state of the dropdown (true for open, false for closed).
   */
  toggleDropdown(index: number, state: boolean) {
    this.openDropdownIndex = state ? index : null;
    this.hoveredIndex = state ? index : null;
  }

  /**
   * Handles the mouse over event for a row.
   * @param index - The index of the row being hovered over.
   */
  onMouseOver(index: number) {
    this.hoveredIndex = index;
  }

  /**
   * Handles the mouse leave event for a row.
   * @param index - The index of the row being left.
   */
  onMouseLeave(index: number) {
    // Only reset hoveredIndex to null if the dropdown is not open for the current row
    if (this.openDropdownIndex !== index) {
      this.hoveredIndex = null;
    }
  }
  async openItem(item: any, event: any) {
    if (item.type === 'folder') {
      if (item.isPasswordProtected && !this.folderPasswordService.isUnlocked(item.id)) {
        const unlocked = await this.promptFolderPassword(item);
        if (!unlocked) return;
      }
      this.router.navigate(['invoices', item.id], {
        queryParams: this.queryParams,
      });
    } else if (item.type === 'invoice') {
      window.open(item.name, '_blank');
    }
  }

  determineIfGoodsAndMaterial(folder: any): string {
    return folder.isLatestScanIncludedProducts === TF.TRUE
      ? 'Goods and Material'
      : 'Regular';
  }


  cancelInvoiceEditing(invoice: any) {
    invoice.title = invoice.originalTitle;
    invoice.isEditing = false;
  }

  openBulkAssignDialog() {
    const dialogRef = this.dialog.open(AssignDialogComponent, {
      data: {
        selectedCount: this.selectedInvoicesNum,
        clientID: this.userID
      }
    });
    dialogRef.afterClosed().subscribe(async (emails: string[]) => {
      if (emails?.length) {
        const selectedInvoices = this.invoices.filter(invoice => invoice.selected);


        try {
          // Create assignments array while filtering out existing assignments
          const assignments = selectedInvoices.reduce((acc: any[], invoice: any) => {
            // Get existing email assignments for this invoice
            const existingEmails = invoice.invoiceUserAssignments?.items?.map((item: any) => item.email) || [];


            // Filter out emails that are already assigned
            const newEmails = emails.filter(email => !existingEmails.includes(email));


            // Create assignment objects for new emails only
            const invoiceAssignments = newEmails.map(email => ({
              invoiceID: invoice.id,
              email: email,
              clientID: this.userID
            }));
            return [...acc, ...invoiceAssignments];
          }, []);

          if (assignments.length === 0) {
            this.snackBar.open('All selected documents are already assigned to these users', '', {
              duration: 3000,
              panelClass: ['orange-snackbar']
            });
            return;
          }

          const result = await this.invoiceService.assignInvoiceToUser(assignments);


          // Update the invoices with new assignments
          selectedInvoices.forEach(invoice => {
            const newAssignments = result.filter(assignment => assignment.invoiceID === invoice.id);
            if (newAssignments.length) {
              if (!invoice.invoiceUserAssignments) {
                invoice.invoiceUserAssignments = { items: [] };
              }
              invoice.invoiceUserAssignments.items.push(...newAssignments);
            }
          });

          this.snackBar.open('Documents assigned successfully', '', {
            duration: 3000,
            panelClass: ['white-snackbar']
          });
          this.toggleAllSelection(false);
        } catch (error) {
          console.error('Error assigning documents:', error);
          this.snackBar.open('Failed to assign documents', '', {
            duration: 3000,
            panelClass: ['red-snackbar']
          });
        }
      }
    });
  }

  // Add these new methods before ngOnDestroy
  onInvoiceDragStarted(invoice: any, event: DragEvent) {
    this.isDraggingInvoice = true;
    this.setDragData(event, 'invoice', invoice);
  }

  onInvoiceDragEnded() {
    this.isDraggingInvoice = false;
    this.dropTargetFolder = null;
    this.isParentFolderDropTarget = false;
  }

  onFolderDragStarted(folder: any, event: DragEvent) {
    this.isDraggingFolder = true;
    this.draggedFolder = folder;
    this.setDragData(event, 'folder', folder);


    // Create a custom drag image
    const dragImage = document.createElement('div');
    dragImage.style.position = 'absolute';
    dragImage.style.top = '-1000px';
    dragImage.style.left = '-1000px';
    dragImage.style.padding = '8px 12px';
    dragImage.style.background = '#ffffff';
    dragImage.style.border = '2px solid #1e31cf';
    dragImage.style.borderRadius = '6px';
    dragImage.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
    dragImage.style.display = 'flex';
    dragImage.style.alignItems = 'center';
    dragImage.style.gap = '8px';
    dragImage.style.minWidth = '200px';
    dragImage.style.maxWidth = '400px';
    dragImage.style.whiteSpace = 'nowrap';
    dragImage.style.overflow = 'hidden';
    dragImage.style.textOverflow = 'ellipsis';


    // Add folder icon
    const icon = document.createElement('span');
    icon.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H10L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.8043 6.97933 22 7.45 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4Z" fill="#1e31cf"/>
      </svg>
    `;


    // Add folder name
    const name = document.createElement('span');
    name.textContent = folder.name;
    name.style.color = '#1e31cf';
    name.style.fontSize = '14px';
    name.style.fontWeight = '500';
    name.style.overflow = 'hidden';
    name.style.textOverflow = 'ellipsis';


    dragImage.appendChild(icon);
    dragImage.appendChild(name);
    document.body.appendChild(dragImage);


    // Set the custom drag image
    event.dataTransfer?.setDragImage(dragImage, 20, 20);


    // Clean up the drag image element after drag starts
    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);
  }

  onFolderDragEnded() {
    this.isDraggingFolder = false;
    this.draggedFolder = null;
    this.dropTargetFolder = null;
    this.isParentFolderDropTarget = false;
  }

  onFolderDragOver(event: any, folder: any) {
    if (this.isDraggingInvoice || this.isDraggingFolder) {
      // Get the dragged item data
      const draggedData = event.dataTransfer?.getData(this.isDraggingInvoice ? 'invoice' : 'folder');
      if (draggedData) {
        const data = window.JSON.parse(draggedData);


        // Check if trying to drop in the same location
        if (this.isDraggingInvoice && data.folderID === folder.id) {
          return; // Don't allow drop in same folder
        }
        if (this.isDraggingFolder && (data.id === folder.id || data.parentFolderID === folder.id)) {
          return; // Don't allow drop in same folder or its own subfolder
        }
      }


      event.preventDefault();
      this.dropTargetFolder = folder;
    }
  }

  onFolderDragLeave() {
    this.dropTargetFolder = null;
  }

  onFolderDrop(event: DragEvent, targetFolder: any) {
    event.preventDefault();
    this.dropTargetFolder = null;

    if (!event.dataTransfer) return;

    if (this.isDraggingInvoice) {
      // Handle invoice drop into folder
      const invoice = event.dataTransfer.getData('invoice');
      if (invoice) {
        const invoiceData = window.JSON.parse(invoice);
        // Check if invoice is already in this folder
        if (invoiceData.folderID === targetFolder.id) {
          console.log('Invoice is already in this folder');
          return;
        }


        // Store the previous state for revert
        this.lastMovedItem = invoiceData;
        this.lastMovedItemType = 'invoice';
        this.lastMovedItemSourceFolder = this.folder;


        this.invoiceService.UpdateInvoice({
          id: invoiceData.id,
          folderID: targetFolder.id
        }).then(() => {
          const snackBarRef = this.snackBar.open('Invoice moved successfully', 'Revert', {
            duration: 5000,
            panelClass: ['white-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            politeness: 'assertive',
            announcementMessage: 'Invoice moved successfully. Click Revert to undo.'
          });

          snackBarRef.onAction().subscribe(() => {
            this.revertLastMove();
          });

          this.invoices = this.invoices.filter((invoice: any) => invoice.id !== invoiceData.id);
          this.changeDetector.detectChanges();
        });
      }
    } else if (this.isDraggingFolder) {
      // Handle folder drop into another folder
      const folder = event.dataTransfer.getData('folder');
      if (folder) {
        const folderData = window.JSON.parse(folder);
        // Check if trying to drop into same folder or its own subfolder
        if (folderData.id === targetFolder.id || folderData.parentFolderID === targetFolder.id) {
          console.log('Cannot drop folder into itself or its own subfolder');
          return;
        }

        // Store the previous state for revert
        this.lastMovedItem = folderData;
        this.lastMovedItemType = 'folder';
        this.lastMovedItemSourceFolder = this.folder;

        this.folderService.UpdateFolder({
          id: folderData.id,
          parentFolderID: targetFolder.id
        }).then(() => {
          const snackBarRef = this.snackBar.open('Folder moved successfully', 'Revert', {
            duration: 5000,
            panelClass: ['white-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            politeness: 'assertive',
            announcementMessage: 'Folder moved successfully. Click Revert to undo.'
          });

          snackBarRef.onAction().subscribe(() => {
            this.revertLastMove();
          });

          this.subfolders = this.subfolders.filter((subfolder: any) => subfolder.id !== folderData.id);
          this.changeDetector.detectChanges();
        });
      }
    }
  }

  onParentFolderDrop(event: DragEvent) {
    event.preventDefault();
    this.isParentFolderDropTarget = false;

    if (!event.dataTransfer) return;

    if (this.isDraggingInvoice) {
      const invoice = event.dataTransfer.getData('invoice');
      if (invoice) {
        const invoiceData = window.JSON.parse(invoice);
        if (invoiceData.folderID === this.folder.parentFolderID) {
          console.log('Invoice is already in parent folder');
          return;
        }

        // Store the previous state for revert
        this.lastMovedItem = invoiceData;
        this.lastMovedItemType = 'invoice';
        this.lastMovedItemSourceFolder = this.folder;

        this.invoiceService.UpdateInvoice({
          id: invoiceData.id,
          folderID: this.folder.parentFolderID
        }).then(() => {
          const snackBarRef = this.snackBar.open('Invoice moved successfully', 'Revert', {
            duration: 5000,
            panelClass: ['white-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            politeness: 'assertive',
            announcementMessage: 'Invoice moved successfully. Click Revert to undo.'
          });

          snackBarRef.onAction().subscribe(() => {
            this.revertLastMove();
          });

          this.invoices = this.invoices.filter((invoice: any) => invoice.id !== invoiceData.id);
          this.changeDetector.detectChanges();
        });
      }
    } else if (this.isDraggingFolder) {
      const folder = event.dataTransfer.getData('folder');
      if (folder) {
        const folderData = window.JSON.parse(folder);
        if (folderData.parentFolderID === this.folder.parentFolderID) {
          console.log('Folder is already in parent folder');
          return;
        }

        // Store the previous state for revert
        this.lastMovedItem = folderData;
        this.lastMovedItemType = 'folder';
        this.lastMovedItemSourceFolder = this.folder;

        this.folderService.UpdateFolder({
          id: folderData.id,
          parentFolderID: this.folder.parentFolderID
        }).then(() => {
          const snackBarRef = this.snackBar.open('Folder moved successfully', 'Revert', {
            duration: 5000,
            panelClass: ['white-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            politeness: 'assertive',
            announcementMessage: 'Folder moved successfully. Click Revert to undo.'
          });

          snackBarRef.onAction().subscribe(() => {
            this.revertLastMove();
          });

          this.subfolders = this.subfolders.filter((subfolder: any) => subfolder.id !== folderData.id);
          this.changeDetector.detectChanges();
        });
      }
    }
  }

  private async revertLastMove() {
    if (!this.lastMovedItem || !this.lastMovedItemType) return;

    try {
      if (this.lastMovedItemType === 'invoice') {
        await this.invoiceService.UpdateInvoice({
          id: this.lastMovedItem.id,
          folderID: this.lastMovedItemSourceFolder.id
        });


        // Refresh the current folder to show the reverted invoice
        await this.getInvoices(this.folder.id, false);
      } else if (this.lastMovedItemType === 'folder') {
        await this.folderService.UpdateFolder({
          id: this.lastMovedItem.id,
          parentFolderID: this.lastMovedItemSourceFolder.id
        });


        // Refresh the current folder to show the reverted subfolder
        await this.getInvoices(this.folder.id, false);
      }

      this.snackBar.open('Move reverted successfully', '', {
        duration: 3000,
        panelClass: ['white-snackbar']
      });
    } catch (error) {
      console.error('Error reverting move:', error);
      this.snackBar.open('Failed to revert move', '', {
        duration: 3000,
        panelClass: ['red-snackbar']
      });
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();


    // Clean up subscription
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  // Add these helper methods before ngOnDestroy
  private setDragData(event: DragEvent, type: 'invoice' | 'folder', data: any) {
    if (event.dataTransfer) {
      event.dataTransfer.setData(type, window.JSON.stringify(data));
    }
  }

  // Add these methods before ngOnDestroy
  onParentFolderDragOver(event: DragEvent) {
    if (this.isDraggingInvoice || this.isDraggingFolder) {
      // Get the dragged item data
      const draggedData = event.dataTransfer?.getData(this.isDraggingInvoice ? 'invoice' : 'folder');
      if (draggedData) {
        const data = window.JSON.parse(draggedData);


        // Check if trying to drop in the same location
        if (this.isDraggingInvoice && data.folderID === this.folder.parentFolderID) {
          return; // Don't allow drop in same folder
        }
        if (this.isDraggingFolder && data.parentFolderID === this.folder.parentFolderID) {
          return; // Don't allow drop in same folder
        }
      }


      event.preventDefault();
      this.isParentFolderDropTarget = true;
    }
  }

  onParentFolderDragLeave() {
    this.isParentFolderDropTarget = false;
  }
}
